import fetchPosts from "../fetch/fetch";

let scriptInitialized = false;

function main() {
  if (scriptInitialized) {
    return;
  }

  scriptInitialized = true;

  const btn = document.querySelector("#news-hero .load-more");
  const loader = document.querySelector("#news-hero .loader");
  const postsPerPage = 8;
  let offset = 0;

  async function getNews() {
    try {
      if (loader) loader.classList.add("show");

      const { data } = await fetchPosts({
        postType: "news",
        action: "fetchPosts",
        postsPerPage,
        offset,
        acfFields: ["single_news_card_img", "single_news_img"],
      });

      renderNews(data);
      toggleLoadMore(data[0]?.have_more_posts);
    } catch (error) {
      console.error("Error fetching news:", error);
    } finally {
      if (loader) loader.classList.remove("show");
    }
  }

  function renderNews(data) {
    const list = document.querySelector("#news-hero .news-list");
    if (!list) {
      console.info("News list element not found!");
      return;
    }

    const template = data
      ?.map((item) => {
        const imageHTML = (item.single_news_card_img || item.single_news_img)
          ? `<div class="news-img">
               <img src="${item.single_news_card_img || item.single_news_img}" alt="${item.title}">
             </div>`
          : "";

        return `
          <li class="news-item">
            ${imageHTML}
            <h3 class="news-title">${item.title}</h3>
            <a class="news-link" href="${item.permalink}">
              ${"Читати більше"}
              <svg xmlns="http://www.w3.org/2000/svg" width="168" height="8" viewBox="0 0 168 8" fill="none">
                <path d="M167.354 4.35355C167.549 4.15829 167.549 3.84171 167.354 3.64645L164.172 0.464466C163.976 0.269204 163.66 0.269204 163.464 0.464466C163.269 0.659728 163.269 0.976311 163.464 1.17157L166.293 4L163.464 6.82843C163.269 7.02369 163.269 7.34027 163.464 7.53553C163.66 7.7308 163.976 7.7308 164.172 7.53553L167.354 4.35355ZM0 4V4.5H167V4V3.5H0V4Z" fill="white" />
              </svg>
            </a>
          </li>
        `;
      })
      .join("");

    list.insertAdjacentHTML("beforeend", template);
  }

  function toggleLoadMore(hasPost) {
    if (!btn) return;
    if (hasPost) {
      btn.classList.add("show");
    } else {
      btn.classList.remove("show");
    }
  }

  function loadMore() {
    offset += postsPerPage;
    getNews();
  }

  getNews();

  if (btn) {
    btn.addEventListener("click", loadMore);
  } else {
    console.info("Load more button not found!");
  }
}

main();

window.addEventListener("resize", () => {
  if (window.innerWidth >= 992 && !scriptInitialized) {
    main();
  }
});
